import React, {useState} from "react"
import MainHeader from "../../mainComponents/Header";
import MainFooter from "mainComponents/MainFooter";
import {Heading} from "../../components";
import {useTranslation} from "react-i18next";
import MainHeaderWithBurger from "../../components/HeaderButton/headerWithBurgerMain";

export default function ServicesPage() {
    const {t} = useTranslation();

    const tabs = [
        {
            id: 'consulting',
            title: t("services.tabs.1.tabsName"),
            tabsTitle: t("services.tabs.1.tabsTitle"),
            tabsDescription: t("services.tabs.1.tabsDescription"),
            content: () =>
                <div className={"bg-[#333333] rounded-[24px] h-[368px] flex justify-center items-center"}>
                    <img
                        src={"/images/services_1.svg"}
                        alt={"Page Logo"}
                        className={"object-contain relative w-[165px] h-[165px]"}/>
                </div>,
        },
        {
            id: 'reports',
            title: t("services.tabs.2.tabsName"),
            tabsTitle: t("services.tabs.2.tabsTitle"),
            tabsDescription: t("services.tabs.2.tabsDescription"),
            content: () =>
                <div className={"bg-[#333333] rounded-[24px] h-[368px] flex justify-center items-center"}>
                    <img
                        src={"/images/services_2.svg"}
                        alt={"Page Logo"}
                        className={"object-contain relative w-[165px] h-[165px]"}/>
                </div>,
        },
        {
            id: 'growth',
            title: t("services.tabs.3.tabsName"),
            tabsTitle: t("services.tabs.3.tabsTitle"),
            tabsDescription: t("services.tabs.3.tabsDescription"),
            content: () =>
                <div className={"bg-[#333333] rounded-[24px] h-[368px] flex justify-center items-center"}>
                    <img
                        src={"/images/services_3.svg"}
                        alt={"Page Logo"}
                        className={"object-contain relative w-[165px] h-[165px]"}/>
                </div>,
        },
        {
            id: 'crm',
            title: t("services.tabs.4.tabsName"),
            tabsTitle: t("services.tabs.4.tabsTitle"),
            tabsDescription: t("services.tabs.4.tabsDescription"),
            content: () =>
                <div className={"bg-[#333333] rounded-[24px] h-[368px] flex justify-center items-center"}>
                    <img
                        src={"/images/services_4.svg"}
                        alt={"Page Logo"}
                        className={"object-contain relative w-[165px] h-[165px]"}/>
                </div>,
        },
        {
            id: 'bi',
            title: t("services.tabs.5.tabsName"),
            tabsTitle: t("services.tabs.5.tabsTitle"),
            tabsDescription: t("services.tabs.5.tabsDescription"),
            content: () =>
                <div className={"bg-[#333333] rounded-[24px] h-[368px] flex justify-center items-center"}>
                    <img
                        src={"/images/services_5.svg"}
                        alt={"Page Logo"}
                        className={"object-contain relative w-[165px] h-[165px]"}/>
                </div>,
        },
        {
            id: 'integration',
            title: t("services.tabs.6.tabsName"),
            tabsTitle: t("services.tabs.6.tabsTitle"),
            tabsDescription: t("services.tabs.6.tabsDescription"),
            content: () =>
                <div className={"bg-[#333333] rounded-[24px] h-[368px] flex justify-center items-center"}>
                    <img
                        src={"/images/services_6.svg"}
                        alt={"Page Logo"}
                        className={"object-contain relative w-[165px] h-[165px]"}/>
                </div>,
        },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const renderContent = () => {
        const tab = tabs.find(tab => tab.id === activeTab);
        return tab ? tab.content : null;
    };

    return (
        <div className={"bg-[#B0B0B0] min-h-screen  flex flex-col"}>
            <div className="md:hidden sm:hidden">
                <MainHeader/>
            </div>
            <div className="lg:hidden">
                <MainHeaderWithBurger/>
            </div>

            <div className={"lg:pb-[160px] md:pb-[100px] sm:pb-[80px] lg:pt-[100px] md:pt-[50px] sm:pt-[80px] lg:px-6 md:px-5 sm:px-4 container-xs"}>

                <div className="flex flex-row md:flex-col sm:flex-col justify-between gap-5 md:gap-[30px] sm:gap-8">

                    {/* Левая часть с табами */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading size={"desktop_heading_2"} className="text-[#191C30E5] whitespace-pre-wrap sm:text-[28px] sm:leading-[120%] sm:uppercase">
                            {t("services.rightTitle")}
                        </Heading>
                        <ul className="mt-10 md:flex md:flex-wrap md:gap-2 sm:flex sm:flex-wrap sm:gap-1.5">
                            {tabs.map(tab => (
                                <li key={tab.id}
                                    className={" md:max-w-none sm:max-w-none"}>
                                    <button
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`text-left text-[15px] leading-6 px-3 py-[10px] rounded-md transition-colors duration-200 outline-none ${
                                            activeTab === tab.id
                                                ? "bg-white shadow text-black border border-[#FFB800]"
                                                : "text-gray-700 hover:bg-gray-200 border border-transparent"
                                        }`}
                                    >
                                        {tab.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Правая часть с контентом */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading
                            size={"desktop_heading_5"}
                            className="text-[#191C30E5] uppercase whitespace-pre-line">
                            {tabs.find(tab => tab.id === activeTab)?.tabsTitle}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className="text-[#191C30E5] whitespace-pre-line mt-4">
                            {tabs.find(tab => tab.id === activeTab)?.tabsDescription}
                        </Heading>
                        <div className="mt-10">
                            {tabs.find(tab => tab.id === activeTab)?.content()}
                        </div>
                    </div>

                </div>

            </div>

            <div className={'mb-0 mt-auto'}>
                <MainFooter/>
            </div>
        </div>

    );
}